import { Icon } from '@blueprintjs/core';
import AppContentView from 'Components/Generic/AppContentView';
import BOSIcon from 'Components/Generic/Misc/BOSIcon';
import BOSHomeButton from 'Components/Generic/Navigation/BOSHomeButton';
import { APP_DESCRIPTION, APP_NAME, NAVIGATION, SITE_PAGES } from 'Config';
import { useAuthContext } from 'Data/context/Auth';
import { Fragment } from 'react';
import { NavLink } from 'react-router';
import { isUserAuthorized } from 'Util';
import BOSFooter from './BOSFooter';
import styles from './Home.module.css';

const Home = () => {
  const { isLoggedIn } = useAuthContext();

  const getTitleAndLinks = (item, index) => {
    if (item.menuItems) {
      return (
        <Fragment key={item.tabId || index}>
          <div className={styles.break} />
          <div>
            {item.title && (
              <div className={styles.sub_section_title}>
                <BOSIcon icon={item.icon} title={item.title} />
              </div>
            )}
            <div className={styles.link_div}>
              {item.menuItems
                .filter(
                  (page) =>
                    !page.requiredAuth || isUserAuthorized(page.requiredAuth),
                )
                .map(getButtonForPage)}
            </div>
          </div>
        </Fragment>
      );
    } else {
      return getButtonForPage(item, index);
    }
  };

  const getWideButtonForPage = (item) => {
    return (
      <NavLink
        className={`${styles.wide_link_button}`}
        to={item.to}
        onMouseDown={(e) => e.preventDefault()}>
        <Icon icon={item.icon} size={36} />
        <span>{item.title || item.text}</span>
      </NavLink>
    );
  };

  const getButtonForPage = (item, index) => {
    return (
      <NavLink
        className={`${styles.link_button}`}
        key={item.tabId || index}
        to={item.to}
        onMouseDown={(e) => e.preventDefault()}>
        <Icon icon={item.icon} size={36} />
        <span>{item.title || item.text}</span>
      </NavLink>
    );
  };

  let links = NAVIGATION.homePageLinks
    .filter((page) => !page.requiredAuth || isUserAuthorized(page.requiredAuth))
    .map(getTitleAndLinks);

  let pageNavigationLinks = <div className={styles.nav_card}>{links}</div>;

  let welcomeElement = (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <BOSHomeButton large disableLink />
      <BOSIcon
        large
        className={styles.welcome_title}
        title={
          <span>
            Welcome to the Health Science Cores
            <span
              style={{ fontStyle: 'italic', marginLeft: 6, fontWeight: 700 }}>
              {APP_NAME}
            </span>
          </span>
        }
      />
      {APP_DESCRIPTION && (
        <span className={styles.app_desc_text}>{APP_DESCRIPTION}</span>
      )}
    </div>
  );

  let loginElement = getWideButtonForPage(SITE_PAGES.LOG_IN);

  return (
    <AppContentView hideBreadcrumbs noPadding title={''} footer={<BOSFooter />}>
      <div
        className={isLoggedIn ? styles.home_card_logged_in : styles.home_card}>
        {welcomeElement}
        {isLoggedIn ? pageNavigationLinks : loginElement}
      </div>
    </AppContentView>
  );
};

export default Home;
